const textareaStyles = (t) => ({
  width: "100%",
  fontSize: "16px",
  lineHeight: "18px",
  ".MuiOutlinedInput-input": {
    lineHeight: "18px",
    fontSize: "14px",
    color: t.palette.grey[800],
    "&::placeholder": {
      color: t.palette.grey[500],
      opacity: 1
    },
    padding: 12,
    transition: "all .1s",
    "&.MuiInputBase-inputSizeSmall": {
      fontSize: "12px",
      padding: 6
    }
  },
  ".MuiInputBase-root": {
    borderRadius: 0,
    border: "none",
    transition: "all .3s",
    padding: 0,
    height: "100%",
    alignItems: "flex-start"
  },
  fieldset: {
    border: `1px solid ${t.palette.grey[400]} !important`
  },
  /// hover
  "@media (hover: hover)": {
    "&:hover": {
      fieldset: {
        borderColor: `${t.palette.grey[500]}!important`
      }
    }
  },
  /// focus
  ".Mui-focused": {
    outline: "none",
    border: "none",
    fieldset: {
      borderColor: `${t.palette.grey[600]}!important`,
      borderWidth: "2px !important"
    }
  },
  /// readonly
  "&.editor-readonly": {
    ".MuiOutlinedInput-input": {
      caretColor: "transparent",
      paddingLeft: 0,
      paddingRight: 0
    },
    fieldset: {
      border: "transparent !important"
    }
  },
  /// error
  "&.editor-error": {
    fieldset: {
      border: `2px solid ${t.palette.radicalRed[900]}!important`
    },
    ".Mui-focused": {
      fieldset: {
        borderColor: `${t.palette.radicalRed[900]}!important`
      }
    }
  },
  /// disabled
  ".Mui-disabled": {
    pointerEvents: "none",
    backgroundColor: t.palette.grey[200],
    fieldset: {
      border: `1px solid ${t.palette.grey[400]}!important`
    },
    textarea: {
      WebkitTextFillColor: t.palette.grey[400]
    }
  }
}), textareaControlStyles = {
  max: {
    mt: 2,
    lineHeight: "18px",
    fontWeight: 500,
    fontSize: "12px",
    whiteSpace: "nowrap",
    height: 24,
    display: "flex"
  },
  hintRow: {
    width: "100%",
    gap: 10,
    justifyContent: "space-between",
    flexDirection: "row"
  },
  labelRow: {
    flexDirection: "row",
    alignItems: "flex-end",
    minHeight: 24,
    gap: 10,
    minWidth: 100,
    height: 20,
    pb: 3
  }
};
export {
  textareaControlStyles,
  textareaStyles
};
//# sourceMappingURL=styles.js.map
